import AlertPopup from "components/dialog";
import { CFNRConfig, CFNR_LOGO } from "constants/common";
import { Spacer } from "ct-design";
import Image from "next/image";
import { ReactNode } from "react";

const CFNRKnowMore = ({
  open,
  onClose,
  minimumBookingValue = CFNRConfig.minimumBookingValue,
  cancelDuration = CFNRConfig.cancelDuration,
}: {
  open: boolean;
  onClose: () => void;
  minimumBookingValue?: number;
  cancelDuration?: number;
}) => {
  return (
    <AlertPopup
      show={open}
      title={
        (
          <Image width={98} height={32} alt="CFNR" src={CFNR_LOGO} />
        ) as ReactNode
      }
      description={
        <ul className="mx-4 fs-16 lh-22">
          <li className="lh-22 mb-4">
            ClearChoice Max is a paid service, and its fees are non-refundable,
            except when the bus is canceled by the operator
          </li>
          <Spacer className="mt-2" />
          <li className="lh-22 mb-4">
            Cancel up to{" "}
            {parseFloat((cancelDuration / 60).toFixed(2).toString())} hours
            before the bus departure time and receive a full refund
          </li>
          <Spacer className="mt-2" />

          <li className="lh-22">
            ClearChoice Max is available for bookings above ₹
            {minimumBookingValue}
          </li>
        </ul>
      }
      descriptionClass="fw-400"
      onClose={onClose}
      centerAlign={false}
      textAlign={false}
      maxWidth="392px"
    />
  );
};

export default CFNRKnowMore;
